import React, { useEffect, useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";
import logo from "../../assets/logos/newLogo.png";
import ForgotPassword from "../Password/ForgotPassword";
import { signIn, signUp } from "./hooks";

const Signup = () => {
  const [isLogin, setIsLogin] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [disableEmail, setDisableEmail] = useState(false);
  const [disableName, setDisableName] = useState(false);
  const [formData, setFormData] = useState({
    key: "",
    name: "",
    email: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showForgotPassword, setShowforgotpassword] = useState(false);

  useEffect(() => {

    // const isUserLoggedIn = localStorage.getItem("userId");
    // if (isUserLoggedIn) {
    //   window.location.href = "/dashboard";
    // }

    const urlParams = new URLSearchParams(window.location.search);
    const emailParam = urlParams.get("email") || "";
    const name = urlParams.get("name") || "";
    const key = urlParams.get("key") || "";
    const type = urlParams.get("type") || "";

    if(key === "") checkUserLoggedIn()

    // console.log("Email Param", emailParam);
    // console.log("Name Param", name);

    setFormData({ ...formData, name, email: emailParam, key });

    if (emailParam) {
      setDisableEmail(true);
    }
    if (name) {
      setDisableName(true);
    }
    if (type === "login") {
      setIsLogin(true);
    }
  }, []);

  const checkUserLoggedIn = () => {
    const userId = localStorage.getItem("userId");
    if (userId) {
      window.location.href = "/dashboard";
    }

  }


  const validatePassword = (password: string) => {
    const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,}$/;
    return passwordRegex.test(password);
  };

  const validate = () => {
    if (
      (formData.email === "" ||
        formData.password === "" ||
        formData.name === "") &&
      isLogin === false
    ) {
      setError("Please fill all the fields");
      console.log("Error", error);
      return false;
    }
    if (
      (formData.email === "" || formData.password === "") &&
      isLogin === true
    ) {
      setError("Please fill all the fields");
      console.log("Error", error);
      return false;
    }
    if (!isLogin) {
      const missingRequirements = [];
      if (formData.password.length < 8) {
        missingRequirements.push("at least 8 characters");
      }
      if (!/\d/.test(formData.password)) {
        missingRequirements.push("number");
      }
      if (!/[a-z]/.test(formData.password)) {
        missingRequirements.push("lowercase letter");
      }
      if (!/[A-Z]/.test(formData.password)) {
        missingRequirements.push("uppercase letter");
      }
      if (missingRequirements.length > 0) {
        setError(`Password must include: ${missingRequirements.join(", ")}`);
        console.log("Error", error);
        return false;
      }
    }
    setError("");
    return true;
  };

  const handleSubmit = (e: React.FormEvent) => {
    if (isLoading) return;
    e.preventDefault();
    console.log(formData);
    if (validate()) {
      console.log("Form Submitted");

      if (!isLogin) {
        setIsLoading(true);
        signUp(formData)
          .then((response) => {
            console.log("API call success:", response);
            if (response.success) {
              localStorage.setItem("userId", response.user.toString());
              window.location.href = "/dashboard";
            } else {
              if (response?.response) {
                setError(response.response);
              }
            }
            setIsLoading(false);
          })
          .catch((error) => {
            alert("Sign up failed");
            console.error("API call failed:", error);
            setIsLoading(false);
          });
      } else {
        setIsLoading(true);
        signIn({ email: formData.email, password: formData.password })
          .then((response) => {
            console.log("API call success:", response);
            if (response.success) {
              localStorage.setItem("userId", response.user.toString());
              window.location.href = "/dashboard";
            } else {
              if (response?.response) {
                setError(response.response);
              }
            }
            setIsLoading(false);
          })
          .catch((error) => {
            setIsLoading(false);
            alert("Login failed");
            console.error("API call failed:", error);
          });
      }
    }
  };

  console.log("Is Login", showForgotPassword);

  if(showForgotPassword) {
    return <ForgotPassword onBack={()=> setShowforgotpassword(false)} />
  }
   
  if (isLogin && !showForgotPassword) {
    return (
      <div className="min-h-screen bg-gray-200 flex flex-col justify-start py-6 sm:px-6 lg:px-8 items-start">
        <div className="sm:mx-auto sm:w-full sm:max-w-md w-full">
          <img className="mx-auto h-12 w-auto" src={logo} alt="Shvesa Logo" />
          <h2 className="mt-6 text-center text-xl leading-9 font-extrabold text-gray-900">
            Login to Your Account
          </h2>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md w-full px-4">
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10 rounded-lg">
            <form className="space-y-6">
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700"
                >
                  Email address
                </label>
                <div className="mt-1">
                  <input
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    required
                    disabled={disableEmail}
                    value={formData.email}
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
                  />
                </div>
              </div>

              <div>
                <label
                  htmlFor="password"
                  className="block text-sm font-medium text-gray-700"
                >
                  Password
                </label>
                <div className="mt-1 relative">
                  <input
                    id="password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    autoComplete="current-password"
                    required
                    value={formData.password}
                    onChange={(e) =>
                      setFormData({ ...formData, password: e.target.value })
                    }
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
                  />
                  <button
                    type="button"
                    className="absolute right-2 top-2 focus:outline-none"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <FiEyeOff className="h-5 w-5 text-gray-400" />
                    ) : (
                      <FiEye className="h-5 w-5 text-gray-400" />
                    )}
                  </button>
                </div>
              </div>

              {error && <div className="text-red-500 text-sm">{error}</div>}

              <div>
                <button
                  type="submit"
                  onClick={handleSubmit}
                  className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#56476E] hover:bg-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                >
                  {isLoading ? "Signing in..." : "Log in"}
                </button>
              </div>

              <div className="text-sm leading-5 w-full text-left">
                <a
                  href="#"
                  className="font-medium text-right text-gray-700 focus:outline-none focus:underline"
                  onClick={() =>{
                    setShowforgotpassword(true)
                    setIsLogin(false)
                  } }
                >
                  Forgot Password ?
                </a>
              </div>

              <div className="flex items-center justify-between">
                <div className="text-sm leading-5">
                  <a
                    href="#"
                    className="font-medium text-primary hover:text-primary focus:outline-none focus:underline"
                    onClick={() => (window.location.href = "/contactus")}
                  >
                    Not a member? Sign up
                  </a>
                </div>
                <div className="text-sm leading-5">
                  <a
                    href="#"
                    className="font-medium text-primary hover:text-primary focus:outline-none focus:underline"
                  >
                    Need help?
                  </a>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  } else if(!isLogin && !showForgotPassword) {
    return (
      <div className="min-h-screen bg-gray-200 flex flex-col justify-start py-12 sm:px-6 lg:px-8 items-start">
        <div className="sm:mx-auto sm:w-full sm:max-w-md w-full">
          <img className="mx-auto h-16 w-auto" src={logo} alt="Shvesa Logo" />
          <h2 className="mt-6 text-center text-xl leading-9 font-extrabold text-gray-900">
            Become an Shvesa Member
          </h2>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md w-full px-4 sm:px-0">
          <div className="bg-white py-8 px-4 shadow rounded-lg sm:px-10">
            <form className="mb-0 space-y-6" action="#" method="POST">
              <div>
                <label
                  htmlFor="name"
                  className="block text-sm font-medium leading-5 text-gray-700"
                >
                  Full Name
                </label>
                <div className="mt-1 rounded-md shadow-sm">
                  <input
                    id="name"
                    type="text"
                    required
                    value={formData.name}
                    disabled={disableName}
                    style={{ opacity: disableName ? 0.4 : 1 }}
                    onChange={(e) =>
                      setFormData({ ...formData, name: e.target.value })
                    }
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
                    placeholder="Johnson Doe"
                  />
                </div>
              </div>

              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium leading-5 text-gray-700"
                >
                  Email address
                </label>
                <div className="mt-1 rounded-md shadow-sm">
                  <input
                    id="email"
                    type="email"
                    required
                    disabled={disableEmail}
                    value={formData.email}
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                    style={{ opacity: disableEmail ? 0.4 : 1 }}
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
                    placeholder="example@email.com"
                  />
                </div>
              </div>

              <div>
                <label
                  htmlFor="password"
                  className="block text-sm font-medium leading-5 text-gray-700"
                >
                  Password
                </label>
                <div className="mt-1 rounded-md shadow-sm relative">
                  <input
                    id="password"
                    type={showPassword ? "text" : "password"}
                    required
                    value={formData.password}
                    onChange={(e) =>
                      setFormData({ ...formData, password: e.target.value })
                    }
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
                    placeholder="********"
                  />
                  <button
                    type="button"
                    className="absolute right-2 top-2 focus:outline-none"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <FiEyeOff className="h-5 w-5 text-gray-400" />
                    ) : (
                      <FiEye className="h-5 w-5 text-gray-400" />
                    )}
                  </button>
                </div>
              </div>

              {error && <div className="text-red-500 text-sm">{error}</div>}

              <div className="flex items-center justify-between">
                <div className="text-sm leading-5">
                  <a
                    href="#"
                    className="font-medium text-primary hover:text-primary focus:outline-none focus:underline"
                    onClick={() => setIsLogin(true)}
                  >
                    Already a member?
                  </a>
                </div>
                <div className="text-sm leading-5">
                  <a
                    href="#"
                    className="font-medium text-primary hover:text-primary focus:outline-none focus:underline"
                  >
                    Need help?
                  </a>
                </div>
              </div>

              <div>
                <span className="block w-full rounded-md shadow-sm">
                  <button
                    type="submit"
                    onClick={handleSubmit}
                    className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-[#56476E] hover:bg-primary focus:outline-none focus:border-primary focus:ring-indigo active:bg-primary transition duration-150 ease-in-out"
                  >
                    {isLoading ? "Signing up..." : "Sign up"}
                  </button>
                </span>
              </div>
            </form>
          </div>
          <div className="flex w-full justify-center py-4">
            <a
              className="text-center text-sm text-primary"
              href="/therapist/signin/"
            >
              Are you a therapist? Sign in here
            </a>
          </div>
        </div>
      </div>
    );
  }
  else  return <div></div>
};

export default Signup;
